/**
 * Link Utils
 *
 * Navigasyon amaçlı tıklamalar `<a href>` semantiğiyle (react-router `<Link>`
 * ya da düz `<a>`) render edilir; böylece "yeni sekmede aç", orta tık,
 * bağlantıyı kopyala ve hover'da URL önizleme gibi native davranışlar çalışır.
 *
 * `<Link>` modifier'lı tıklamada (Ctrl/Cmd/Shift/Alt veya orta tık) preventDefault
 * yapmaz, tarayıcıya bırakır. Ancak onClick handler'ı yine de tetiklenir; bu
 * yüzden yan etkiler (modal kapatma, analytics, state reset) modifier'lı
 * tıklamada çalıştırılmamalıdır — kullanıcı mevcut sayfada kalıyor.
 */

/**
 * Tıklamanın "yeni sekmede aç" niyeti taşıyıp taşımadığını söyler.
 * true dönerse navigasyon yeni sekmede olacak, mevcut sayfa değişmeyecektir.
 */
export const isModifiedClick = (
  e: React.MouseEvent | React.KeyboardEvent,
): boolean => {
  if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return true;
  // Orta tık (button === 1) yeni sekmede açar; sadece sol tık (0) in-page navigasyondur.
  if ("button" in e && e.button !== 0) return true;
  return false;
};
